export default "__VITE_ASSET__ab40f2ea__"